import { useEffect, useState } from "react";
import { subscribeToJob } from "@hostdock/sdk";
import type { JobLogRecord, JobRecord } from "@hostdock/types";
import { api } from "../api";

/** Live job state and log lines over SSE (the customer's own jobs only). */
export function useLiveJob(jobId: string | null) {
  const [job, setJob] = useState<JobRecord | null>(null);
  const [logs, setLogs] = useState<JobLogRecord[]>([]);
  useEffect(() => {
    setJob(null);
    setLogs([]);
    if (!jobId) return;
    return subscribeToJob(api.jobs.eventsUrl(jobId), (e) => {
      setJob(e.job);
      if (e.log) setLogs((l) => (l.some((x) => x.id === e.log!.id) ? l : [...l, e.log!]));
    });
  }, [jobId]);
  return { job, logs };
}
